import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2, BookOpen, Droplet, Ban, Calendar, Pill } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function DeliverablesSection() {
  const items = [{
    icon: <BookOpen className="w-6 h-6 text-emerald" data-id="element-35" />,
    title: 'El Manual Principal: Detox de Inflamación Celular',
    desc: 'PDF de lectura rápida y profunda.'
  }, {
    icon: <Droplet className="w-6 h-6 text-emerald" data-id="element-36" />,
    title: 'La Receta del Suero Maestro',
    desc: 'La mezcla exacta para hidratar tus órganos en 240 horas.'
  }, {
    icon: <Ban className="w-6 h-6 text-emerald" data-id="element-37" />,
    title: 'Lista Negra de Alimentos Latinos',
    desc: 'Qué ingredientes de tu despensa están saboteando tus rodillas hoy mismo.'
  }, {
    icon: <Calendar className="w-6 h-6 text-emerald" data-id="element-38" />,
    title: 'El Plan de 10 Días',
    desc: 'Menú detallado paso a paso para eliminar la hinchazón.'
  }, {
    icon: <Pill className="w-6 h-6 text-emerald" data-id="element-39" />,
    title: 'Guía de Suplementación Inteligente',
    desc: 'Solo lo que funciona (Magnesio y Cúrcuma).'
  }];
  return <section className="py-20 bg-white" data-id="element-40">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-41">
        <FadeIn data-id="element-42">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-forest mb-12" data-id="element-43">
            Todo lo que recibes hoy
          </h2>
        </FadeIn>

        <div className="bg-sand/20 rounded-3xl p-6 md:p-10 border border-sand/50" data-id="element-44">
          <div className="space-y-6" data-id="element-45">
            {items.map((item, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-46">
                <div className="flex items-start gap-4 bg-white p-5 rounded-2xl shadow-sm" data-id="element-47">
                  <div className="bg-emerald/10 p-3 rounded-full flex-shrink-0" data-id="element-48">
                    {item.icon}
                  </div>
                  <div data-id="element-49">
                    <h4 className="font-bold text-forest text-lg" data-id="element-50">
                      {item.title}
                    </h4>
                    <p className="text-gray-600 text-sm mt-1" data-id="element-51">{item.desc}</p>
                  </div>
                </div>
              </FadeIn>)}
          </div>

          {/* BONUS EXTRA */}
          <FadeIn delay={0.6} data-id="element-52">
            <div className="mt-8 relative overflow-hidden rounded-2xl border-2 border-emerald bg-gradient-to-r from-forest to-forest-light text-white" data-id="element-53">
              <div className="absolute top-0 right-0 bg-emerald text-white text-xs font-bold uppercase tracking-wider px-4 py-1.5 rounded-bl-xl" data-id="element-54">
                🎁 Bonus Extra
              </div>
              <div className="flex flex-col md:flex-row items-center gap-6 p-6 md:p-8" data-id="element-55">
                <img src="https://cdn.magicpatterns.com/uploads/sEp6nM8WVk5PTwguqd7pZi/9-qVoCC2ZPZUQ64obG-wj.png" alt="El Ritual Nocturno de 6 Minutos" className="w-full md:w-48 h-48 object-cover rounded-xl flex-shrink-0" data-id="element-56" />
                <div data-id="element-57">
                  <h4 className="font-bold text-xl md:text-2xl text-cream mb-2 font-serif" data-id="element-58">
                    El Ritual Nocturno de 6 Minutos
                  </h4>
                  <p className="text-emerald-light font-medium text-sm mb-2" data-id="element-59">
                    de Vitalizateahora
                  </p>
                  <p className="text-gray-300 text-sm leading-relaxed" data-id="element-60">
                    Una rutina relajante antes de dormir que potencia la
                    reparación celular mientras descansas. Solo 6 minutos para
                    desinflamar, calmar tu sistema nervioso y despertar
                    renovado.
                  </p>
                  <p className="text-emerald-light font-bold mt-3 text-sm" data-id="element-61">
                    INCLUIDO GRATIS con tu compra hoy
                  </p>
                </div>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.7} className="mt-10 text-center" data-id="element-62">
            <CTAButton data-id="element-63" />
          </FadeIn>
        </div>
      </div>
    </section>;
}